import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// QUINLAN
import BaseMixer from "@/router/views/BaseMixer";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
let RejectEntryComponent = /** @class */ (() => {
    let RejectEntryComponent = class RejectEntryComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isLoading = false;
            this.reason = "";
        }
        showModal() {
            this.reason = "";
            this.$bvModal.show("reject_entry");
        }
        hideModal() {
            this.$bvModal.hide("reject_entry");
        }
        rejectingEntry() {
            this.validate("rejectObserver").then((response) => {
                if (response) {
                    this.$emit("rejectingEntry", this.reason);
                }
            });
        }
        cancel() {
            this.hideModal();
            this.$emit("cancel");
        }
        addFocus() {
            this.setFocusToInput("rejectReasonTextarea");
        }
        created() { }
        destroyed() { }
    };
    RejectEntryComponent = __decorate([
        Component({
            name: "RejectEntryComponent",
            components: {
                SectionLoader,
            },
        })
    ], RejectEntryComponent);
    return RejectEntryComponent;
})();
export default RejectEntryComponent;
